export enum DashboardEnum {
    USERS = 'USERS',
    SPEACHES = 'SPEACHES',
    SOCIAL = 'SOCIAL'
}
